// Tiny global toast bus. No external dep.
import { useEffect, useState } from 'react';

export type Toast = { id: string; text: string; kind?: 'success' | 'error' | 'info' };

type Listener = (toasts: Toast[]) => void;
const listeners = new Set<Listener>();
let toasts: Toast[] = [];

function emit() {
  for (const l of listeners) l([...toasts]);
}

export function pushToast(text: string, kind: Toast['kind'] = 'info') {
  const id = Math.random().toString(36).slice(2);
  toasts = [...toasts, { id, text, kind }];
  emit();
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== id);
    emit();
  }, 3200);
}

export function useToasts(): Toast[] {
  const [list, setList] = useState<Toast[]>(toasts);
  useEffect(() => {
    listeners.add(setList);
    return () => {
      listeners.delete(setList);
    };
  }, []);
  return list;
}
